import BackboneElement from './BackboneElement';
import merge from 'lodash/merge';

export default class CoverageEligibilityResponseInsuranceItemBenefitEffectivePeriod extends BackboneElement {
    static __className = 'CoverageEligibilityResponseInsuranceItemBenefitEffectivePeriod';

    __objectStructure = {
        dateQualifier: String,
        dateOfServiceEnd: String,
        dateOfServiceStart: String,
    };

    constructor(constructJson, className = 'CoverageEligibilityResponseInsuranceItemBenefitEffectivePeriod') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
